import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

import ShopsContext from "../../../../context/ShopsContext";

function DeleteSegmentModal({ show, handleClose, product, segment, onDeleted }) {
    const shopsContext = useContext(ShopsContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const reset = useCallback(() => {
        setLoading(false);
        setError(null);
    }, []);

    const handleDelete = useCallback(async () => {
        if(!segment) return;
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post("/deleteRentalProductSegment", {
                shopId: shopsContext.currentShop.id,
                productId: product.id,
                segmentId: segment.id,
            });
            if(response.data.valid) {
                handleClose();
                onDeleted?.();
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
        setLoading(false);
    }, [shopsContext.currentShop.id, product, segment, handleClose, onDeleted]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ reset }>
            <Modal.Header closeButton>
                <Modal.Title>Segment verwijderen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <p className="mb-0">
                    Weet je zeker dat je dit segment wilt verwijderen?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleren
                </Button>
                <Button variant="danger" onClick={ handleDelete } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Verwijderen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
DeleteSegmentModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    segment: PropTypes.object,
    onDeleted: PropTypes.func,
}

export default React.memo(DeleteSegmentModal);
